import { render, staticRenderFns } from "./PaginationCommon.vue?vue&type=template&id=1edd5e2e&scoped=true&"
import script from "./PaginationCommon.vue?vue&type=script&lang=js&"
export * from "./PaginationCommon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1edd5e2e",
  null
  
)

export default component.exports